// extracted by mini-css-extract-plugin
export default {"root":"Dates-module__[local]___4NOwu","new":"Dates-module__[local]___F4aJg","private":"Dates-module__[local]___+kTR0"};